import { action } from "satcheljs";

export interface UpdateIsSuiteHeaderRenderedActionMessage {
    isRendered: boolean;
}
export const updateIsSuiteHeaderRendered: (isRendered: boolean) => UpdateIsSuiteHeaderRenderedActionMessage = action("updateIsSuiteHeaderRendered", (isRendered: boolean): UpdateIsSuiteHeaderRenderedActionMessage => ({ isRendered }));

export interface UpdateShySuiteHeaderModeActionMessage {
    isShy: boolean;
}
export const updateShySuiteHeaderMode: (isShy: boolean) => UpdateShySuiteHeaderModeActionMessage = action("updateShySuiteHeaderMode", (isShy: boolean): UpdateShySuiteHeaderModeActionMessage => ({
    isShy,
}));
